<template>
  <a v-if="show" class="all-reports-link" :href="`#${hgReportAnchor}`">All Reports</a>
</template>

<script>
export default {
  props: {
    hgReportAnchor: {
      type: String,
      required: true,
    },
    hgReportCount: {
      type: Number,
      required: true,
    },
    hgReportBlock: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    show() {
      return !this.hgReportBlock && this.hgReportCount > 1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/typography';

.all-reports-link {
  font-size: 0.929rem;
  font-weight: $typography-weight-bold;
  margin-top: 20px;
  text-decoration: underline;
  text-transform: uppercase;
}

@media all and (max-width: 655px) {
  .all-reports-link {
    margin-top: 40px;
  }
}
</style>
